type StickySummaryVisibilityOptions = {
  /** Drop the in-flow sticky view's height so y=0 of the scroller lines up with the view below it. */
  stackedAboveScroll?: boolean;
  stickyHeight?: number;
  fudge?: number;
  hideUntilScrolled?: boolean;
};

/**
 * `productContentY` is the product header's y inside the scrolling content.
 * `stickyY` is the pinned header's y in its parent. Subtracting `scrollY`
 * reproduces the old pageY comparison without measuring on each scroll frame.
 */
export const isStickySummaryVisible = (
  productContentY: number,
  scrollY: number,
  stickyY: number,
  stickyContainerHeight: number,
  options?: StickySummaryVisibilityOptions
) => {
  const stickyOrigin = options?.stackedAboveScroll
    ? stickyY - (options.stickyHeight ?? 0)
    : stickyY;
  const productPosition = productContentY - scrollY;
  const visible =
    productPosition - stickyOrigin - (options?.fudge ?? 0) <=
    stickyContainerHeight;

  if (options?.hideUntilScrolled && scrollY === 0) {
    return false;
  }

  return visible;
};
